// Dollars typed by staff ("500", "$1,250.50") to integer cents, parsed as text: no float maths on money.
export function parseDollars(s: string): number | null {
  const m = s.trim().replace(/^\$/, '').replace(/,/g, '').match(/^(\d{1,9})(?:\.(\d{0,2}))?$/)
  if (!m) return null
  return Number(m[1]) * 100 + Number((m[2] ?? '').padEnd(2, '0'))
}
